module.exports = __webpack_public_path__ + "style/img/RE_icon_Location.bd0b9bfc.png";